import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import BlogForm from "./BlogForm";
import { addBlog } from "../../api/BlogService";

const BlogAdd = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const initialValues = {
    title: "",
    slug: "",
    description: "",
    blogCategory: "",
    productCategory: "",
    author: "",
    readingTime: "",
    seoTitle: "",
    seoDescription: "",
    keywords: "",
    content: "",
    status: "ACTIVE",
    coverImage: null,
  };

  const handleSubmit = async (values) => {
    try {
      setLoading(true);
      setErrors({});

      const payload = {
        title: values.title,
        excerpt: values.excerpt,

        // Required fields
        category: values.category,
        productCategory: values.productCategory,

        author: values.author,
        publishedDate: values.publishedDate,
        readingTime: Number(values.readingTime),
        content: values.content,
        status: values.status,

        // SEO
        metaTitle: values.metaTitle,
        metaDescription: values.metaDescription,
        metaKeywords: Array.isArray(values.metaKeywords)
          ? values.metaKeywords.filter((item) => item.trim() !== "")
          : values.metaKeywords
            ? values.metaKeywords
                .split(",")
                .map((item) => item.trim())
                .filter((item) => item !== "")
            : [],

        coverImage: values.coverImage,
      };

      const res = await addBlog(payload);

      if (res.success) {
        navigate("/blog");
        return;
      }

      if (res.error) {
        setErrors(res.error);
      }
    } catch (error) {
      console.error("API ERROR", error);

      if (error?.response?.data?.error) {
        setErrors(error.response.data.error);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <BlogForm
      initialValues={initialValues}
      onSubmit={handleSubmit}
      loading={loading}
      errors={errors}
      onCancel={() => navigate("/blog")}
    />
  );
};

export default BlogAdd;
